<template>
  <!-- FormKit placeholder input — registered to satisfy layer-formkit module -->
  <input
    v-bind="props?.context?.attrs"
    :value="props?.context?._value"
    @input="(e) => props?.context?.node?.input((e.target as HTMLInputElement).value)"
  >
</template>

<script setup lang="ts">
const props = defineProps({
  context: Object,
})
</script>
